// IF YOU CHANGE THIS FILE, YOU MUST ALSO CHANGE THE FILE IN THE NEXT LOCATIONS:
//  - portal-backend - src/modules/sitemap/localized-paths.ts
import { AvailableLocale } from '@/i18n/types'

export const en = {
    game: 'game/:game',
    category: 'category/:hru',
    tag: 'tag/:hru',
    series: 'series/:hru',
    contacts: 'contacts',
    profile: 'profile',
    shop: 'shop',
    invite: 'invite/:inviteCode',
    allCategories: 'all/categories',
    allTags: 'all/tags',
    allSeries: 'all/series',
    confidential: 'confidential',
    termsofuse: 'termsofuse',
    takedown_notice: 'takedown-notice',
    license: 'license',
    partners_api: 'partners-api',
    myGames: 'my-games',
    digitalServiceAсt: 'digital-service-act',
}

export type LocalizedPaths = typeof en

export const es: LocalizedPaths = {
    game: 'juego/:game',
    category: 'categoria/:hru',
    tag: 'etiqueta/:hru',
    series: 'serie/:hru',
    contacts: 'contactos',
    profile: 'perfil',
    shop: 'tienda',
    invite: 'invitar/:inviteCode',
    allCategories: 'todas/categorias',
    allTags: 'todas/etiquetas',
    allSeries: 'todas/series',
    confidential: 'confidencial',
    termsofuse: 'terminosdeuso',
    takedown_notice: 'aviso-de-eliminacion',
    license: 'licencia',
    partners_api: 'api-de-socios',
    myGames: 'mis-juegos',
    digitalServiceAсt: 'ley-de-servicios-digitales',
}

export const de: LocalizedPaths = {
    game: 'spiel/:game',
    category: 'kategorie/:hru',
    tag: 'tag/:hru',
    series: 'serie/:hru',
    contacts: 'kontakte',
    profile: 'profil',
    shop: 'laden',
    invite: 'einladen/:inviteCode',
    allCategories: 'alle/kategorien',
    allTags: 'alle/tags',
    allSeries: 'alle/serien',
    confidential: 'vertraulich',
    termsofuse: 'nutzungsbedingungen',
    takedown_notice: 'entfernungsmitteilung',
    license: 'lizenz',
    partners_api: 'partner-api',
    myGames: 'meine-spiele',
    digitalServiceAсt: 'gesetz-uber-digitale-dienste',
}

export const fr: LocalizedPaths = {
    game: 'jeu/:game',
    category: 'categorie/:hru',
    tag: 'tag/:hru',
    series: 'serie/:hru',
    contacts: 'contacts',
    profile: 'profil',
    shop: 'boutique',
    invite: 'inviter/:inviteCode',
    allCategories: 'toutes/categories',
    allTags: 'toutes/tags',
    allSeries: 'toutes/series',
    confidential: 'confidentiel',
    termsofuse: 'conditions-dutilisation',
    takedown_notice: 'avis-de-retrait',
    license: 'licence',
    partners_api: 'api-partenaires',
    myGames: 'mes-jeux',
    digitalServiceAсt: 'loi-sur-les-services-numeriques',
}

export const it: LocalizedPaths = {
    game: 'gioco/:game',
    category: 'categoria/:hru',
    tag: 'tag/:hru',
    series: 'serie/:hru',
    contacts: 'contatti',
    profile: 'profilo',
    shop: 'negozio',
    invite: 'invita/:inviteCode',
    allCategories: 'tutte/categorie',
    allTags: 'tutte/tag',
    allSeries: 'tutte/serie',
    confidential: 'riservato',
    termsofuse: 'termini-di-uso',
    takedown_notice: 'avviso-di-rimozione',
    license: 'licenza',
    partners_api: 'api-partner',
    myGames: 'i-miei-giochi',
    digitalServiceAсt: 'legge-sui-servizi-digitali',
}

export const ptBr: LocalizedPaths = {
    game: 'jogo/:game',
    category: 'categoria/:hru',
    tag: 'tag/:hru',
    series: 'serie/:hru',
    contacts: 'contatos',
    profile: 'perfil',
    shop: 'loja',
    invite: 'convidar/:inviteCode',
    allCategories: 'todas/categorias',
    allTags: 'todas/tags',
    allSeries: 'todas/series',
    confidential: 'confidencial',
    termsofuse: 'termos-de-uso',
    takedown_notice: 'aviso-de-remocao',
    license: 'licenca',
    partners_api: 'api-parceiros',
    myGames: 'meus-jogos',
    digitalServiceAсt: 'lei-dos-servicos-digitais',
}

export const tr: LocalizedPaths = {
    game: 'oyun/:game',
    category: 'kategori/:hru',
    tag: 'etiket/:hru',
    series: 'seri/:hru',
    contacts: 'iletisim',
    profile: 'profil',
    shop: 'magaza',
    invite: 'davet/:inviteCode',
    allCategories: 'tum/kategoriler',
    allTags: 'tum/etiketler',
    allSeries: 'tum/seriler',
    confidential: 'gizli',
    termsofuse: 'kullanim-kosullari',
    takedown_notice: 'kaldirma-bildirimi',
    license: 'lisans',
    partners_api: 'ortaklar-api',
    myGames: 'oyunlarim',
    digitalServiceAсt: 'dijital-hizmetler-yasasi',
}

export const pl: LocalizedPaths = {
    game: 'gra/:game',
    category: 'kategoria/:hru',
    tag: 'tag/:hru',
    series: 'seria/:hru',
    contacts: 'kontakty',
    profile: 'profil',
    shop: 'sklep',
    invite: 'zaproszenie/:inviteCode',
    allCategories: 'wszystkie/kategorie',
    allTags: 'wszystkie/tagi',
    allSeries: 'wszystkie/serie',
    confidential: 'poufne',
    termsofuse: 'warunki-uzytkowania',
    takedown_notice: 'powiadomienie-o-usunieciu',
    license: 'licencja',
    partners_api: 'api-partnerow',
    myGames: 'moje-gry',
    digitalServiceAсt: 'ustawa-o-uslugach-cyfrowych',
}

export const id: LocalizedPaths = {
    game: 'permainan/:game',
    category: 'kategori/:hru',
    tag: 'tag/:hru',
    series: 'seri/:hru',
    contacts: 'kontak',
    profile: 'profil',
    shop: 'toko',
    invite: 'undang/:inviteCode',
    allCategories: 'semua/kategori',
    allTags: 'semua/tag',
    allSeries: 'semua/seri',
    confidential: 'rahasia',
    termsofuse: 'ketentuan-penggunaan',
    takedown_notice: 'pemberitahuan-penghapusan',
    license: 'lisensi',
    partners_api: 'api-mitra',
    myGames: 'permainanku',
    digitalServiceAсt: 'undang-undang-layanan-digital',
}

export const allLocalizedPaths: Record<AvailableLocale, LocalizedPaths> = {
    'en-US': en,
    'es-ES': es,
    'de-DE': de,
    'fr-FR': fr,
    'it-IT': it,
    'pt-BR': ptBr,
    'tr-TR': tr,
    'pl-PL': pl,
    'id-ID': id,
}
